import { render, staticRenderFns } from "./ProductVariantPropagation.vue?vue&type=template&id=36dfbc97&"
import script from "./ProductVariantPropagation.vue?vue&type=script&lang=ts&"
export * from "./ProductVariantPropagation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports